/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ConditionExpression,
  ConditionExpression$inboundSchema,
} from "./conditionexpression.js";
import { DisplayRef, DisplayRef$inboundSchema } from "./displayref.js";

/**
 * The sequencer configuration, it's limited because it appears on the Details Page of another Device.
 */
export type SequencerConfigState = {
  /**
   * Defines a condition expression. Can be a single condition, a group of conditions, or nested groups. Exactly one of 'condition', 'condition_group', or 'nested_expression' must be specified.
   */
  conditionExpression?: ConditionExpression | undefined;
  /**
   * The alias of the sequencer device.
   */
  deviceAlias?: string | undefined;
  /**
   * The id of the sequencer device.
   */
  deviceId?: string | undefined;
  /**
   * The readings to display, this displays readings in the Sequencer section of the Equipment Details Screen.
   */
  displayMetrics: Array<DisplayRef>;
  /**
   * The name of the sequencer config. Usually used for debug purposes.
   */
  displayName?: string | undefined;
  /**
   * The settings to display, this displays settings in the Sequencer section of the Equipment Details Screen.
   */
  displaySettings: Array<DisplayRef>;
  /**
   * Whether this state is the default state. If this is true, conditions are not required. For readability, these states should be at the end of the array.
   */
  isDefault: boolean;
  /**
   * The priority of the state. There is no constraint on overlapping conditions, so this field allows user to set priority.
   */
  priority: number;
  /**
   * The name of the state
   */
  stateName: string;
};

/** @internal */
export const SequencerConfigState$inboundSchema: z.ZodType<
  SequencerConfigState,
  z.ZodTypeDef,
  unknown
> = z.object({
  condition_expression: types.optional(ConditionExpression$inboundSchema),
  device_alias: types.optional(types.string()),
  device_id: types.optional(types.string()),
  display_metrics: z.array(DisplayRef$inboundSchema),
  display_name: types.optional(types.string()),
  display_settings: z.array(DisplayRef$inboundSchema),
  is_default: types.boolean().default(false),
  priority: types.number().default(0),
  state_name: types.string(),
}).transform((v) => {
  return remap$(v, {
    "condition_expression": "conditionExpression",
    "device_alias": "deviceAlias",
    "device_id": "deviceId",
    "display_metrics": "displayMetrics",
    "display_name": "displayName",
    "display_settings": "displaySettings",
    "is_default": "isDefault",
    "state_name": "stateName",
  });
});

export function sequencerConfigStateFromJSON(
  jsonString: string,
): SafeParseResult<SequencerConfigState, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SequencerConfigState$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SequencerConfigState' from JSON`,
  );
}
